import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PublicHome } from "./pages/public/PublicHome";
import { PublicReleases } from "./pages/public/PublicReleases";
import { PublicArticles } from "./pages/public/PublicArticles";
import { PublicArticle } from "./pages/public/PublicArticle";
import { PublicLegal } from "./pages/public/PublicLegal";
import { PublicContact } from "./pages/public/PublicContact";
import { PublicTop } from "./pages/public/PublicTop";
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AdminHome } from "./pages/admin/AdminHome";
import { AdminArticles } from "./pages/admin/AdminArticles";
import { AdminArticleEditor } from "./pages/admin/AdminArticleEditor";
import { AdminSorties } from "./pages/admin/AdminSorties";
import { AdminLogs } from "./pages/admin/AdminLogs";
import { AdminSettings } from "./pages/admin/AdminSettings";
import { AdminUsers } from "./pages/admin/AdminUsers";
import { AdminMessages } from "./pages/admin/AdminMessages";
import { AdminCoverageAudit } from "./pages/admin/AdminCoverageAudit";
import { AdminEngagement } from "./pages/admin/AdminEngagement";
import { AdminNewsletter } from "./pages/admin/AdminNewsletter";
import { AdminManualReleases } from "./pages/admin/AdminManualReleases";
import { PublicNewsletter } from "./pages/public/PublicNewsletter";
import { LogoCompare } from "./pages/LogoCompare";
import { CookieConsent } from "./components/public/CookieConsent";
import { ReleaseModalProvider } from "./components/public/ReleaseModal";
import { ScrollToTop } from "./components/ScrollToTop";
import { AnalyticsTracker } from "./components/public/AnalyticsTracker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AnalyticsTracker />
          <ScrollToTop />
          <ReleaseModalProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<PublicHome />} />
            <Route path="/sorties" element={<PublicReleases />} />
            <Route path="/deja-dans-les-salles" element={<PublicReleases key="deja-films" preset={{ kind: "Film", released_only: true }} />} />
            <Route path="/deja-sur-vos-ecrans" element={<PublicReleases key="deja-series" preset={{ kind: "Série", released_only: true }} />} />
            <Route path="/top" element={<PublicTop />} />
            <Route path="/articles" element={<PublicArticles />} />
            <Route path="/articles/:slug" element={<PublicArticle />} />
            <Route path="/mentions-legales" element={<PublicLegal />} />
            <Route path="/contact" element={<PublicContact />} />
            <Route path="/newsletter" element={<PublicNewsletter />} />
            <Route path="/logo-compare" element={<LogoCompare />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminHome />} />
              <Route path="articles" element={<AdminArticles />} />
              <Route path="articles/nouveau" element={<AdminArticleEditor />} />
              <Route path="articles/:id" element={<AdminArticleEditor />} />
              <Route path="sorties" element={<AdminSorties />} />
              <Route path="engagement" element={<AdminEngagement />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="sorties-manuelles" element={<AdminManualReleases />} />
              <Route path="audit-couverture" element={<AdminCoverageAudit />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="historique" element={<AdminLogs />} />
              <Route path="utilisateurs" element={<AdminUsers />} />
              <Route path="reglages" element={<AdminSettings />} />
            </Route>
          </Routes>
          </ReleaseModalProvider>
        </AuthProvider>
        <CookieConsent />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "white",
              border: "1px solid #e8e4de",
              color: "#111",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
